import { createContext, useContext } from 'react';

// Make sure to add any new exports to src/provider/index.ts!
export const ICONOGRAPHY_REFRESH = 'iconography-refresh-early-adoption-2025-06';

type IFeaturePreviewContext = {
	[key in string]?: boolean;
};

// Add more feature flags (with their default values), as needed
export const FeaturePreviewContext = createContext<IFeaturePreviewContext>({
	[ICONOGRAPHY_REFRESH]: false,
});

export const useFeaturePreviewContext = () => useContext(FeaturePreviewContext);

export const FeaturePreviewProvider = FeaturePreviewContext.Provider;
